import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import { styles } from './formStyles';
import BetIcon from '../../images/icons/bet_icon.png';

const YourBetBadge = ({ t, highestBetValue, }) => {
  const classes = useStyles();
  return (
    <div className={classes.noBets}>
      <img alt="bets_icon" src={BetIcon} />
      <span>{t('your_offer_is_highest')} <strong dataTestId="yourBetValue"> {highestBetValue} &euro; </strong> </span>
    </div>
  );
};

YourBetBadge.propTypes = {
  t: PropTypes.func.isRequired,
  highestBetValue: PropTypes.number.isRequired,
};

const useStyles = createUseStyles({
  noBets: {
    backgroundColor: 'white',
    border: `1px solid ${styles.colors.green}`,
    borderRadius: '4px',
    display: 'flex',
    padding: '0.8em',
    fontSize: '14px',
    alignItems: 'center',
    '& img': {
      width: '25px',
      marginRight: '0.3em',
    },
    '& span': {
      color: styles.colors.dark,
    },
  },
});

export default YourBetBadge;
